// frontend/src/pages/ResetPassword.jsx

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const [senha, setSenha] = useState('');
    const [confirmSenha, setConfirmSenha] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    // Redirecionar se o token não estiver presente
    useEffect(() => {
        if (!token) {
            navigate('/forgot-password');
        }
    }, [token, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        // Verifica se as senhas coincidem
        if (senha !== confirmSenha) {
            setError('As senhas não coincidem.');
            return;
        }

        try {
            const res = await api.post('/auth/reset-password', { token, senha });
            setMessage(res.data.msg);
            // Opcional: Redirecionar para o login após algum tempo
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            console.error('Erro ao redefinir senha:', err);
            setError(err.response?.data?.msg || 'Erro ao redefinir senha.');
        }
    };

    return (
        <div
            className="w-screen h-screen flex justify-center items-center bg-cover bg-center"
            style={{
                backgroundImage: `url('/images/login_background.png')`,
            }}
        >
            {/* Formulário de Redefinição de Senha */}
            <div className="w-[406px] p-6 bg-white rounded-lg border border-slate-300 flex flex-col justify-center items-center gap-6">
                {/* Título */}
                <h2 className="text-2xl font-medium text-stone-800">Redefinir Senha</h2>

                {/* Mensagem de Sucesso */}
                {message && <p className="text-green-600">{message}</p>}

                {/* Mensagem de Erro */}
                {error && <p className="text-red-600">{error}</p>}

                {/* Formulário */}
                {!message && (
                    <form onSubmit={handleSubmit} className="w-full">
                        {/* Campo de Nova Senha */}
                        <div className="flex flex-col gap-1 mb-4">
                            <label htmlFor="senha" className="text-slate-700 text-sm font-medium">
                                Nova Senha
                            </label>
                            <input
                                id="senha"
                                name="senha"
                                type="password"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                required
                                className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Digite sua nova senha"
                            />
                        </div>

                        {/* Campo de Confirmar Nova Senha */}
                        <div className="flex flex-col gap-1 mb-4">
                            <label htmlFor="confirmSenha" className="text-slate-700 text-sm font-medium">
                                Confirmar Nova Senha
                            </label>
                            <input
                                id="confirmSenha"
                                name="confirmSenha"
                                type="password"
                                value={confirmSenha}
                                onChange={(e) => setConfirmSenha(e.target.value)}
                                required
                                className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Confirme sua nova senha"
                            />
                        </div>

                        {/* Botão de Redefinir Senha */}
                        <button
                            type="submit"
                            className="w-full px-4 py-2 bg-stone-600 text-white rounded-md hover:bg-stone-700 transition duration-200"
                        >
                            Redefinir Senha
                        </button>
                    </form>
                )}

                {/* Link para a Página de Login */}
                <div className="mt-4">
                    <button onClick={() => navigate('/')} className="text-blue-500 hover:underline">
                        Voltar para o Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
